const LocationIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.6667 10.3333C17.6667 13.6 12.3333 19 12.3333 19C12.3333 19 7 13.6 7 10.3333C7 6.93333 9.73333 5 12.3333 5C14.9333 5 17.6667 6.93333 17.6667 10.3333Z"
        stroke="#999999"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12.333 12.334C13.4376 12.334 14.333 11.4386 14.333 10.334C14.333 9.22941 13.4376 8.33398 12.333 8.33398C11.2284 8.33398 10.333 9.22941 10.333 10.334C10.333 11.4386 11.2284 12.334 12.333 12.334Z"
        stroke="#999999"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default LocationIcon;
